// extracted by mini-css-extract-plugin
module.exports = {"image":"style_image__2EcK_","container":"style_container__1p0T-","title":"style_title__2ufn8"};